module.exports = __webpack_public_path__ + "media/images/features/7/plan-album2-2845b64d74c3f1fcbc533c5595149202.jpg";